/**
 * @description 會員註冊 step2 會員身分用
 */
export enum SignupMembership {
  /** 一般會員 */
  Normal = '0',
  /** 網投會員 */
  Web = '1',
  /** Line 會員 */
  Line = '2',
  /** App 會員 */
  App = '3'
}
